import { createStore } from 'vuex'
import price from './price'
import catalog from './catalog'
import faq from './faq'
import reviews from './reviews'
import contacts from './contacts'

export default createStore({
  state: {
    orderModalOpen: false,
    /** Выбранная картина из витрины для модалки «Запрос на покупку» */
    orderModalCatalogItem: null,
    /** Размер, подставляемый при открытии из блока цен (кнопка «Хочу») */
    orderModalPreselectedSizeKey: null,
    questionModalOpen: false,
    reviewModalOpen: false,
    termsModalOpen: false,
    toast: { message: '', show: false }
  },
  mutations: {
    setOrderModalOpen(state, value) {
      state.orderModalOpen = !!value
      if (!value) {
        state.orderModalCatalogItem = null
        state.orderModalPreselectedSizeKey = null
      }
    },
    setOrderModalPreselectedSizeKey(state, sizeKey) {
      state.orderModalPreselectedSizeKey = sizeKey || null
    },
    setOrderModalCatalogItem(state, item) {
      state.orderModalCatalogItem = item || null
    },
    setQuestionModalOpen(state, value) {
      state.questionModalOpen = !!value
    },
    setReviewModalOpen(state, value) {
      state.reviewModalOpen = !!value
    },
    setTermsModalOpen(state, value) {
      state.termsModalOpen = !!value
    },
    setToast(state, message) {
      state.toast.message = message || ''
      state.toast.show = !!message
    }
  },
  modules: {
    price,
    catalog,
    faq,
    reviews,
    contacts
  }
})
